/* ==========================================================================
   oddit-search-drawer.js — Search Drawer open/close/toggle
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('.oddit-search-drawer');
  if (!root) return;

  var overlay = root.querySelector('[data-search-overlay]');
  // The search field and close button live in the header, not in this drawer.
  var header = document.querySelector('.oddit-header');
  var input = document.querySelector('[data-search-input]');
  var closeBtn = document.querySelector('[data-search-close]');
  var savedScrollY = 0;
  var closeTimer = null;

  function open() {
    savedScrollY = window.scrollY;
    // Otherwise the mobile menu stays open behind the drawer, showing its own search row.
    if (window.OdditHeader) window.OdditHeader.closeMenus();
    root.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (header) {
      window.clearTimeout(closeTimer);
      header.classList.remove('is-search-closing');
      header.classList.add('is-search-open');
    }
    // After the class: on mobile the header gains a search row, so its height changes.
    if (window.OdditHeader) window.OdditHeader.syncOffset();
    if (input) input.focus();
  }

  function close() {
    // Reopening should land on trending/popular, not the last query's results.
    if (input) input.value = '';
    showDefault();
    root.classList.remove('is-visible');
    document.body.style.overflow = '';
    if (header) {
      // Keep the expanded layout until the collapse animation has played out.
      window.clearTimeout(closeTimer);
      header.classList.add('is-search-closing');
      closeTimer = window.setTimeout(function () {
        header.classList.remove('is-search-open');
        header.classList.remove('is-search-closing');
      }, 300);
    }
    if (input) input.blur();
    window.scrollTo(0, savedScrollY);
  }

  function toggle() {
    root.classList.contains('is-visible') ? close() : open();
  }

  if (overlay) overlay.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-visible')) close();
  });

  /* ------------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------------ */

  var defaultEl = root.querySelector('[data-search-default-content]');
  var resultsEl = root.querySelector('[data-search-results]');
  var loadingEl = root.querySelector('[data-search-loading]');
  var emptyEl = root.querySelector('[data-search-empty]');
  var viewAllEl = root.querySelector('[data-search-view-all]');
  var groups = {
    products: root.querySelector('[data-search-products]'),
    collections: root.querySelector('[data-search-collections]'),
    articles: root.querySelector('[data-search-articles]')
  };
  var types = root.getAttribute('data-search-resource-types') || 'product,collection,article';
  var limit = parseInt(root.getAttribute('data-search-results-limit'), 10) || 4;
  var searchUrl = (viewAllEl && viewAllEl.getAttribute('href') || '/search?q=').split('?')[0];
  var MIN_CHARS = 2;
  var debounceTimer = null;
  var controller = null;

  // Results come back as rendered HTML from sections/oddit-search-drawer-results.liquid,
  // so cards match the Liquid card exactly — rating, highlight and swatches included.
  // /search/suggest.json cannot carry those: they live in metafields.
  function renderGroup(key, node) {
    var el = groups[key];
    if (!el) return 0;
    if (!node) {
      el.innerHTML = '';
      el.style.display = 'none';
      return 0;
    }
    el.innerHTML = node.innerHTML;
    // Injected after page load, so the reveal IntersectionObserver never sees these
    // cards and they stay at opacity 0. Results should appear at once anyway.
    el.querySelectorAll('.oddit-reveal').forEach(function (n) { n.classList.add('is-visible'); });
    el.style.display = '';
    return el.querySelectorAll('.oddit-search-drawer__card, .oddit-search-drawer__result').length;
  }

  function showDefault() {
    if (controller) { controller.abort(); controller = null; }
    if (defaultEl) defaultEl.style.display = '';
    if (resultsEl) resultsEl.style.display = 'none';
    if (viewAllEl) viewAllEl.style.display = 'none';
  }

  function render(doc, query) {
    var total = 0;
    Object.keys(groups).forEach(function (key) {
      total += renderGroup(key, doc.querySelector('[data-results-group="' + key + '"]'));
    });
    if (loadingEl) loadingEl.style.display = 'none';
    if (emptyEl) emptyEl.style.display = total ? 'none' : '';
    if (viewAllEl) {
      viewAllEl.style.display = total ? '' : 'none';
      viewAllEl.setAttribute('href', searchUrl + '?q=' + encodeURIComponent(query));
    }
  }

  function search(query) {
    if (controller) controller.abort();
    controller = new AbortController();

    if (defaultEl) defaultEl.style.display = 'none';
    if (resultsEl) resultsEl.style.display = '';
    if (emptyEl) emptyEl.style.display = 'none';
    if (loadingEl) loadingEl.style.display = '';

    var url = '/search/suggest?q=' + encodeURIComponent(query) +
      '&resources[type]=' + encodeURIComponent(types) +
      '&resources[limit]=' + limit +
      // Without limit_scope the limit is a budget shared across all types, which
      // left the product grid showing a single card.
      '&resources[limit_scope]=each' +
      '&section_id=oddit-search-drawer-results';

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Search failed: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        render(new DOMParser().parseFromString(html, 'text/html'), query);
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        // Leave the shopper a way forward rather than a spinner that never resolves.
        if (loadingEl) loadingEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = '';
        if (viewAllEl) {
          viewAllEl.style.display = '';
          viewAllEl.setAttribute('href', searchUrl + '?q=' + encodeURIComponent(query));
        }
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < MIN_CHARS) {
        showDefault();
        return;
      }
      debounceTimer = setTimeout(function () { search(query); }, 250);
    });
  }

  window.OdditSearchDrawer = { open: open, close: close, toggle: toggle };
})();